/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';
// IMPORT - COMPONENTS
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class BundleTable extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
   */
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      data: {},
    };
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.get();
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   */
  get() {
    this.setState({
      loading: true,
    }, () => {
      this.request(
        // callback
        (response) => {
          if (response.bundle) {
            this.setState({
              loading: false,
              data: response.bundle,
            });
          }
        },
        // failback
        (error) => {
          // eslint-disable-next-line no-console
          console.error(error);
        },
      );
    });
  }

  /**
   * @param {function} callback
   * @param {function} failback
   */
  request(callback, failback) {
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/bundles/${this.props.id}`,
      'get',
      null,
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <>
        {(this.state.loading)
          ? (<Loader />)
          : (
            <div className="table-responsive">
              <table className="table table-bordered">
                <tr>
                  <th>Firmware</th>
                </tr>
                <tr>
                  <td>
                    {(this.state.data.firmware
                    && Object.keys(this.state.data.firmware).length > 0)
                      ? (
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Version</th>
                              </tr>
                            </thead>
                            <tbody>
                              <td>{(this.state.data.firmware.version || 'None')}</td>
                            </tbody>
                          </table>
                        </div>
                      )
                      : 'No Firmware Details'}
                  </td>
                </tr>
                <tr>
                  <th>APKS</th>
                </tr>
                <tr>
                  <td>
                    {(this.state.data.apks && this.state.data.apks.length > 0)
                      ? (
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Version</th>
                                <th>Package</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.data.apks.map((item) => (
                                <tr key={`apk-${item.package_name}`}>
                                  <td>{item.version}</td>
                                  <td>{item.package_name}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )
                      : 'No Apk Details'}
                  </td>
                </tr>
              </table>
            </div>
          )}

      </>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
BundleTable.propTypes = {
  id: PropTypes.number,
};

/* ===========================
EXPORT
=========================== */
export default BundleTable;
